
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 264 2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Line 3","fill":"none","stroke":"#05c3dd","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"2","stroke-dasharray":"0 4.667","d":"M263 1H1"}})])
          )
        }
      }
    